import { dataGeoServiciosFetch } from "../helpers/fetch";
import { types } from "../types/types";
// import dataMock from '../helpers/mocks/mockResponse.json';


const sendGis = (data) => {
    return {
        type: types.gisSetPoint,
        payload: data,
    }
};


export const sendGeoPointAndGetInfo = ({pointID}) => {
    return async (dispatch) => {
        try {
            const body = await (dataGeoServiciosFetch(
                {
                    solicitud:"meteoActual",
                    idSAT: pointID
                },
                'POST'
            ));
            console.log('body response fetch',body);
            dispatch(sendGis(body))
        } catch (error) {
            console.error('No se obtuvo información del punto seleccionado');
            dispatch(sendGis({
                dataBar: null,
                dataPronostico: [],
            }))
        }
    }
}